import { Directive, HostListener, Input } from "@angular/core";
import { Router } from "@angular/router";
import { AuthService } from "src/app/core/services/auth.service";
import { ApiService } from "../services/api.service";
import { PermissionService } from "../services/permission.service";

@Directive({
  selector: "[appLogout]",
})
export class LogoutDirective {
  public urlRedirect: string[];

  @Input("appLogout")
  set setUrl(val: string[]) {
    const isAdmin = this.permissionService.hasAdminPermission();
    this.urlRedirect =
      !val || val.length === 0 ? ["/", isAdmin ? "admin" : "logon"] : val;
  }

  constructor(
    private authService: AuthService,
    private router: Router,
    private apiService: ApiService,
    private permissionService: PermissionService
  ) {}

  @HostListener("click")
  onClick() {
    this.apiService.zerarCacheDeRequests();
    this.permissionService.clearPermissions();
    this.doLogout();
  }

  doLogout(): void {
    this.authService.doLogout().subscribe(() => {
      this.router.navigate(this.urlRedirect);
    });
  }
}
